import React from 'react';

const FileIcon = ({ size = 14, color = "#55000C", strokeWidth = 1.25, className = "", ...props }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 14 17" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M10.2083 0.625H3.54167C1.93084 0.625 0.625 1.93084 0.625 3.54167V13.125C0.625 14.7358 1.93084 16.0417 3.54167 16.0417H10.2083C11.8192 16.0417 13.125 14.7358 13.125 13.125V3.54167C13.125 1.93084 11.8192 0.625 10.2083 0.625Z" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M3.95898 3.96289H9.79232M3.95898 7.29622H9.79232M3.95898 10.6296H6.87565" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default FileIcon;